import React from 'react'
import { getImages } from '../const'
import UseScrollReveal from '../Common/UseScrollReveal '

const HomeAward = () => {
    UseScrollReveal();
    return (
        <>
            <section className='award-wrap'>
                <div className='container'>
                    <div className='text-center'>
                        <div className='d-inline-flex align-items-center justify-content-between'>
                            <div className='wow fadeIn reveal' >
                                <img src={getImages('badge.webp')} />
                            </div>
                            <h2 className='award-title wow fadeIn reveal'>
                                <span className='d-inline-block px-5 year-title'>2024</span>
                                <span>Global Retailer of the Year</span>
                            </h2>
                            <div className='wow fadeIn reveal ps-md-5' >
                                <img src={getImages('badge.webp')} />
                            </div>
                            {/* <div className='wow fadeIn reveal d-none d-lg-block'>
                                <a href='#' className='learn-more-btn text-uppercase'>Learn More</a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeAward